import React, { useState, useEffect } from "react";
import api from "../../utils/Api";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { FileDown } from "lucide-react";

const estadoBadge = {
  pendiente: "tn-badge tn-badge--yellow",
  resuelta:  "tn-badge tn-badge--green",
  rechazada: "tn-badge tn-badge--red",
};

export default function ListadoIncidenciasT() {
  const [state, setState] = useState({
    empleados: [], filtroEmpleado: "", tipo: "", estado: "",
    fechaInicio: "", fechaFin: "", incidencias: [], loading: false, error: null,
    paginaActual: 1, registrosPorPagina: 10,
  });

  const formatearFecha = (fecha) => {
    const [fechaParte] = fecha.split(" ");
    const [a, m, d] = fechaParte.split("-");
    return `${d}/${m}/${a}`;
  };

  const fetchEmpleados = async () => {
    try {
      const res = await api.get("/usuarios");
      setState((prev) => ({ ...prev, empleados: res.data }));
    } catch {
      setState((prev) => ({ ...prev, error: "Error cargando empleados" }));
    }
  };

  const fetchIncidencias = async (filtros = {}) => {
    setState((prev) => ({ ...prev, loading: true }));
    try {
      const soloEmpleado = filtros.empleado
        && !filtros.fechaInicio && !filtros.fechaFin && !filtros.tipo && !filtros.estado;

      const res = soloEmpleado
        ? await api.get(`/incidencias/empleado/${filtros.empleado}`)
        : await api.post("/incidencias/listado", filtros);

      setState((prev) => ({ ...prev, incidencias: res.data.data, paginaActual: 1, error: null }));
    } catch (err) {
      setState((prev) => ({ ...prev, incidencias: [], error: err?.message || "Error cargando incidencias" }));
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => { fetchEmpleados(); }, []);

  const generarPDF = async () => {
    const { filtroEmpleado, fechaInicio, fechaFin, tipo, estado, empleados } = state;
    try {
      const res = await api.post("/incidencias/listado", {
        empleado: filtroEmpleado || undefined,
        fechaInicio: fechaInicio || undefined,
        fechaFin: fechaFin || undefined,
        tipo: tipo || undefined,
        estado: estado || undefined,
      });
      const incidencias = res.data.data;
      const empleado = empleados.find((e) => e.id === Number(filtroEmpleado));
      const doc = new jsPDF();
      doc.setFontSize(18); doc.setTextColor(254, 127, 37);
      doc.text("Listado de Incidencias", 14, 20);
      doc.setFontSize(10); doc.setTextColor(0);
      doc.text(`Empleado: ${empleado?.nombre || "Todos"}`, 14, 30);
      doc.text(`Periodo: ${fechaInicio || "-"} / ${fechaFin || "-"}`, 14, 35);
      autoTable(doc, {
        startY: 45,
        head: [["Empleado", "Fecha", "Tipo", "Descripción", "Estado"]],
        body: incidencias.map((i) => [i.usuario?.nombre, formatearFecha(i.fecha_hora), i.tipo, i.descripcion, i.estado]),
        theme: "grid",
        headStyles: { fillColor: [254, 127, 37] },
      });
      doc.save("incidencias.pdf");
    } catch {
      setState((prev) => ({ ...prev, error: "Error generando PDF" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { filtroEmpleado, fechaInicio, fechaFin, tipo, estado } = state;
    if (fechaInicio && fechaFin && fechaInicio > fechaFin) { setState((prev) => ({ ...prev, error: "La fecha inicio no puede ser mayor" })); return; }
    fetchIncidencias({
      empleado: filtroEmpleado || undefined,
      fechaInicio: fechaInicio || undefined,
      fechaFin: fechaFin || undefined,
      tipo: tipo || undefined,
      estado: estado || undefined,
    });
  };

  const { paginaActual, registrosPorPagina, incidencias } = state;
  const indiceUltimo = paginaActual * registrosPorPagina;
  const indicePrimero = indiceUltimo - registrosPorPagina;
  const incidenciasPaginadas = incidencias.slice(indicePrimero, indiceUltimo);
  const totalPaginas = Math.ceil(incidencias.length / registrosPorPagina);

  return (
    <div>
      <h1 className="tn-page-title">Listado de incidencias</h1>
      <p className="tn-page-sub">Consulta y exporta el registro de incidencias</p>

      <div className="tn-card" style={{ padding: 20, marginBottom: 20 }}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 14, marginBottom: 14 }}>
            <div>
              <label className="tn-label">Empleado</label>
              <select className="tn-input tn-select" value={state.filtroEmpleado}
                onChange={(e) => setState((prev) => ({ ...prev, filtroEmpleado: e.target.value }))}>
                <option value="">Todos</option>
                {state.empleados.map((e) => <option key={e.id} value={e.id}>{e.nombre}</option>)}
              </select>
            </div>
            <div>
              <label className="tn-label">Tipo</label>
              <select className="tn-input tn-select" value={state.tipo}
                onChange={(e) => setState((prev) => ({ ...prev, tipo: e.target.value }))}>
                <option value="">Todos</option>
                <option value="falta">Falta</option>
                <option value="retraso">Retraso</option>
                <option value="incidencia">Incidencia</option>
              </select>
            </div>
            <div>
              <label className="tn-label">Estado</label>
              <select className="tn-input tn-select" value={state.estado}
                onChange={(e) => setState((prev) => ({ ...prev, estado: e.target.value }))}>
                <option value="">Todos</option>
                <option value="pendiente">Pendiente</option>
                <option value="resuelta">Resuelta</option>
                <option value="rechazada">Rechazada</option>
              </select>
            </div>
            <div>
              <label className="tn-label">Fecha inicio</label>
              <input type="date" className="tn-input" value={state.fechaInicio}
                onChange={(e) => setState((prev) => ({ ...prev, fechaInicio: e.target.value }))} />
            </div>
            <div>
              <label className="tn-label">Fecha fin</label>
              <input type="date" className="tn-input" value={state.fechaFin}
                onChange={(e) => setState((prev) => ({ ...prev, fechaFin: e.target.value }))} />
            </div>
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button type="submit" className="tn-btn tn-btn--primary" disabled={state.loading}>
              {state.loading ? "Cargando…" : "Consultar"}
            </button>
            <button type="button" className="tn-btn tn-btn--ghost" onClick={generarPDF} disabled={!incidencias.length}
              style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <FileDown size={15} /> <span>Exportar PDF</span>
            </button>
          </div>
        </form>
      </div>

      {state.error && <div className="tn-alert tn-alert--danger" style={{ marginBottom: 16 }}>{state.error}</div>}

      <div className="tn-card">
        <div className="tn-table-wrap">
          <table className="tn-table">
            <thead>
              <tr><th>Empleado</th><th>Fecha</th><th>Tipo</th><th>Descripción</th><th>Estado</th></tr>
            </thead>
            <tbody>
              {incidenciasPaginadas.length === 0 ? (
                <tr><td colSpan="5" style={{ textAlign: "center", padding: "40px 20px", color: "var(--clr-muted)" }}>Sin registros — aplica los filtros y pulsa Consultar</td></tr>
              ) : incidenciasPaginadas.map((i) => (
                <tr key={i.id}>
                  <td data-label="Empleado">{i.usuario?.nombre}</td>
                  <td data-label="Fecha">{formatearFecha(i.fecha_hora)}</td>
                  <td data-label="Tipo" style={{ textTransform: "capitalize" }}>{i.tipo}</td>
                  <td data-label="Descripción">{i.descripcion}</td>
                  <td data-label="Estado">
                    <span className={estadoBadge[i.estado] || "tn-badge tn-badge--slate"}>{i.estado}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {totalPaginas > 1 && (
          <div className="tn-pagination" style={{ padding: "12px 16px", borderTop: "1px solid var(--clr-border)" }}>
            <button className="tn-page-btn" disabled={paginaActual === 1}
              onClick={() => setState(prev => ({ ...prev, paginaActual: prev.paginaActual - 1 }))}>‹</button>
            {[...Array(totalPaginas)].map((_, i) => (
              <button key={i} className={`tn-page-btn${paginaActual === i + 1 ? " active" : ""}`}
                onClick={() => setState(prev => ({ ...prev, paginaActual: i + 1 }))}>{i + 1}</button>
            ))}
            <button className="tn-page-btn" disabled={paginaActual === totalPaginas}
              onClick={() => setState(prev => ({ ...prev, paginaActual: prev.paginaActual + 1 }))}>›</button>
          </div>
        )}
      </div>
    </div>
  );
}
